import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { getWorkingArea } from "../../../../redux/reducer/workingArea/workingAreaReducer";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { getUnitWeight } from "../../../../redux/reducer/unitWeight/unitWeightReducer";
import { getVegetableType } from "../../../../redux/reducer/vegetableType/vegetableTypeReducer";
import {
  getVegetableById,
  updateVegetable,
  vegetableActions,
} from "../../../../redux/reducer/vegetable/vegetableReducer";
import Swal from "sweetalert2";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px 20px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
}));
export default function AdminVegetableDetail() {
  // Navigate
  const navigate = useNavigate();
  const id = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const vegetable = useSelector((state) => state.vegetable.data);
  const unitWeight = useSelector((state) => state.unitWeight.data);
  const workingArea = useSelector((state) => state.workingArea.data);
  const vegetableType = useSelector((state) => state.vegetableType.data);

  // Local State
  const [formData, setFormData] = useState({
    vegetableName: "",
    vegetableTypeId: "",
    unitWeightId: "",
    weightInGrams: "",
    harvestTime: "",
    workingAreaId: "",
  });
  const [fetch, setFetch] = useState(true);

  // Init Edit Data
  useEffect(() => {
    if (fetch) {
      const x = vegetable.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setFormData({
          vegetableName: vegetable.docs[x].vegetableName
            ? vegetable.docs[x].vegetableName
            : "",
          vegetableTypeId: vegetable.docs[x].vegetableTypeId
            ? vegetable.docs[x].vegetableTypeId._id
            : "",
          vegetableTypeName: vegetable.docs[x].vegetableTypeId
            ? vegetable.docs[x].vegetableTypeId.typeName
            : "",
          unitWeightId: vegetable.docs[x].unitWeight
            ? vegetable.docs[x].unitWeight.unitWeightId._id
            : "",
          unitWeightName: vegetable.docs[x].unitWeight
            ? vegetable.docs[x].unitWeight.unitWeightId.unitName
            : "",
          weightInGrams: vegetable.docs[x].unitWeight
            ? vegetable.docs[x].unitWeight.weightInGrams
            : "",
          harvestTime: vegetable.docs[x].harvestTime
            ? vegetable.docs[x].harvestTime
            : "",
          workingAreaId: vegetable.docs[x].workingAreaId
            ? vegetable.docs[x].workingAreaId._id
            : "",
          workingAreaName: vegetable.docs[x].workingAreaId
            ? vegetable.docs[x].workingAreaId.areaName
            : "",
        });
        setFetch(false);
      }
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (
        vegetableType.totalDocs !== vegetableType.docs.length &&
        value === 1
      ) {
        const getData = {
          params: {
            limit: vegetableType.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getVegetableType(getData));
      } else if (
        unitWeight.totalDocs !== unitWeight.docs.length &&
        value === 2
      ) {
        const getData = {
          params: {
            limit: unitWeight.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getUnitWeight(getData));
      } else if (
        workingArea.totalDocs !== workingArea.docs.length &&
        value === 3
      ) {
        const getData = {
          params: {
            limit: workingArea.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getWorkingArea(getData));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      token: token,
      value: {
        vegetableName: formData.vegetableName,
        vegetableTypeId: formData.vegetableTypeId,
        unitWeight: {
          unitWeightId: formData.unitWeightId,
          weightInGrams: formData.weightInGrams,
        },
        harvestTime: formData.harvestTime,
        workingAreaId: formData.workingAreaId,
      },
      id: id.id,
    };
    Swal.fire({
      title: `Periksa kembali data yang akan ditambahkan`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        dispatch(updateVegetable(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getVegetableById(dataGetById)).then((res) => {
              if (res) {
                dispatch(vegetableActions.editVegetable(res.payload.data));
                navigate("/admin/sayuran");
              }
            });
          } else {
            toast.error(res.payload.message);
          }
        });
      } else {
        return;
      }
    });
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items paddingLeft={2}>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DETAIL HARGA SAYURAN
            </Typography>
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "2%",
            width: "100%",
          }}
          onSubmit={handleSubmit}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="17%"
            >
              NAMA SAYURAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              inputProps={{
                maxLength: 15,
                style: { background: "white" },
                readOnly: true,
              }}
              name="vegetableName"
              onChange={handleChange}
              value={formData.vegetableName}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="17%"
            >
              TIPE SAYURAN
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="vegetableTypeId"
              onChange={handleChange}
              value={formData.vegetableTypeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.vegetableTypeName &&
              formData.vegetableTypeId.length > 0 ? (
                <MenuItem value={formData.vegetableTypeId}>
                  {formData.vegetableTypeName}
                </MenuItem>
              ) : (
                ""
              )}
              {vegetableType.docs.length > 0 ? (
                vegetableType.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.typeName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="17%"
            >
              TIPE SATUAN BERAT
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="unitWeightId"
              onChange={handleChange}
              value={formData.unitWeightId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(2),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.unitWeightName && formData.unitWeightId.length > 0 ? (
                <MenuItem value={formData.unitWeightId}>
                  {formData.unitWeightName}
                </MenuItem>
              ) : (
                ""
              )}
              {unitWeight.docs.length > 0 ? (
                unitWeight.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.unitName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="17%"
            >
              BERAT DALAM GRAM
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              type="number"
              inputProps={{ style: { background: "white" }, readOnly: true }}
              name="weightInGrams"
              onChange={handleChange}
              value={formData.weightInGrams}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="17%"
            >
              WAKTU PANEN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              type="number"
              inputProps={{ style: { background: "white" }, readOnly: true }}
              name="harvestTime"
              onChange={handleChange}
              value={formData.harvestTime}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="17%"
            >
              AREA
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="workingAreaId"
              onChange={handleChange}
              value={formData.workingAreaId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(3),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.workingAreaName && formData.workingAreaId.length > 0 ? (
                <MenuItem value={formData.workingAreaId}>
                  {formData.workingAreaName}
                </MenuItem>
              ) : (
                ""
              )}
              {workingArea.docs.length > 0 ? (
                workingArea.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.areaName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              onClick={() => navigate("/admin/sayuran")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
